<template>
	<div class="my-table logManagementPage">
		<!-- 面包屑组件 -->
		<div class="searchBox relative">
			<div class="current-location">
				<img class="location" src="@/assets/picture/icon/location.png">
				<span>{{$t('logManagement.txt1')}}</span>
				<span>{{$t('logManagement.txt2')}} / {{$t('logManagement.txt3')}}</span>
			</div>
		</div>
			<!-- 面包屑 -->
			<el-card class="tableCard p30 mt0">
				<div class=" flexCenterBtn">
					<Tag></Tag>
				</div>
				<el-table :data="dataList" :default-sort="{prop: 'logLevel', order: 'descending'}">
					<el-table-column :label="$t('logManagement.txt4')" type="index" width="50">
					</el-table-column>
					<el-table-column :label="$t('logManagement.txt5')">
						<template slot-scope="scope">
							<span>{{scope.row.logLevel?scope.row.logLevel:'--'}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('logManagement.txt6')" >
						<template slot-scope="scope">
							<span>{{scope.row.logModel?scope.row.logModel:'--'}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('logManagement.txt7')">
						<template slot-scope="scope">
							<span>{{scope.row.methodName?scope.row.methodName:'--'}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('logManagement.txt8')" width="300">
						<template slot-scope="scope">
							<span>{{scope.row.userId?scope.row.userId:'--'}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('logManagement.txt9')">
						<template slot-scope="scope">
							<span>{{scope.row.userName?scope.row.userName:'--'}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('logManagement.txt10')">
						<template slot-scope="scope">
							<span>{{formatDate(scope.row.createTime)}}</span>
						</template>
					</el-table-column>
				</el-table>
			</el-card>
			<div class="table-footer tablePagination  mt-50" v-show="total>0">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="queryInfo.pageNum" :page-sizes="[10, 20, 30, 40]"
				layout="total, sizes, prev, pager, next" :page-size="queryInfo.pageSize"
				:total="total">
			</el-pagination>
		</div>
		
	</div>
</template>

<script>
	import { formatDate } from "@/plugins/date.js";
	import qs from 'qs';
	import Tag from './components/tag.vue';
	import menuMixin from './menuMixin';
	export default {
		mixins: [menuMixin],
		components: {
			Tag
		},
		data() {
			return {
				isIndeterminate: true,
				time: '',
				//用于获取数据列表
				queryInfo: {
					pageNum:0,
					size:10,
				},
				dataList: [],
				total: 0,
			};
		},
		created() {
			this.loadData();
		},
		methods: {
			formatDate(time) {
				var date = new Date(time);
				return formatDate(date, "yyyy-MM-dd hh:mm:ss");
			},
			handleSearch(){
				this.queryInfo.pageNum = 1;
				this.loadData();
			},
			// 数据加载
			async loadData() {
				let data = {};
				if(this.queryInfo.logLevel){
					data.logLevel = this.queryInfo.logLevel
				}
				if(this.queryInfo.logModel){
					data.logModel = this.queryInfo.logModel
				}
				if(this.queryInfo.userName){
					data.userName = this.queryInfo.userName
				}
				data.pageNum = this.queryInfo.pageNum;
				data.size = this.queryInfo.size;
				const { data: res } = await this.$http.post("/log/list?" + qs.stringify(data));
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.dataList = res.result.content;
				this.total = res.result.totalElements;
			},
			// 返回上一页
			returnPage() {
				this.$router.go(-1);
			},
			// 页面切换
			handleCurrentChange(pageNum) {
				this.queryInfo.pageNum = pageNum;
				this.loadData();
			},
			handleSizeChange(pageSize) {
				this.queryInfo.size = pageSize;
				this.loadData();
			},
		},
	};
</script>

<style lang="less" scoped>
	.logManagementPage {
		.back {
			display: inline-block;
			margin-right: 2.6rem;

			img {
				width: 1.8rem;
				height: 1.8rem;
				margin-right: 0.7rem;
			}

			span {
				font-size: 1.6rem;
				font-weight: 400;
				color: #333333;
			}
		}
		.mt-50{
			margin-top: -60px;
		}
		.w16 {
			width: 16rem;

			/deep/ .el-input,
			/deep/ .el-input__inner {
				width: 100% !important;
			}
		}

		.mb15 {
			margin-bottom: 1.5rem;
		}

		.searchBox {
			/*width: 33.6rem !important;*/
			height: 3.2rem;

			.btnC {
				padding: 0.6rem 2.6rem;
			}
		}

		.tips {
			font-size: 1.4rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #98B9FF;
			margin-top: -10px;
		}

		/deep/ .el-dialog {
			/deep/ .el-input,
			/deep/ .el-input__inner {
				width: 100% !important;
			}

			// /deep/ .el-form-item:first-of-type,
			// /deep/ .el-form-item:last-of-type {
				// 	margin-bottom: 0;
				// }

				/deep/ .el-dialog .el-dialog__body .el-select .el-input__inner,
				.el-dialog .el-dialog__body .el-input__inner,
				.el-dialog .el-dialog__body .el-input {
					border-radius: 8px;
				}
			}
		}
		.handleBtn{
			padding: 0;
		}
	</style>
